import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { AppSettings } from 'src/app/app.settings';
import { BasePage } from 'src/app/core/basepages/allbasepages';
import { LocalstorageService } from 'src/app/services/localstorage.service';

@Component({
    selector: 'app-useruompref',
    templateUrl: './useruompref.component.html',
    styleUrls: ['./useruompref.component.scss']
})
export class UserUOMPrefComponent extends BasePage implements OnInit {
    @Input() userUOMID: number;
    @Output() private userUOMPrefUpdated: EventEmitter<number> = new EventEmitter<number>();

    constructor(
        localstorageService: LocalstorageService,
        logger: NGXLogger,
        appSettings: AppSettings,
    ) {
        super(localstorageService, logger, appSettings);
    }

    ngOnInit() {
    }

    UOMChanged(event){
        this.userUOMID = event.value;
        this.userUOMPrefUpdated.emit(event.value);
    }
}